import { render, staticRenderFns } from "./KdsStationForm.vue?vue&type=template&id=ab83d27a&"
import script from "./KdsStationForm.vue?vue&type=script&lang=js&"
export * from "./KdsStationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports